import RNFetchBlob from 'react-native-blob-util';
import { REACT_APP_BASE_API } from './api.config';
import { getJWT } from './api.helper';
import { Platform } from 'react-native';
import Share from 'react-native-share';
let isSharing = false;

const shareAttachment = async (path: string) => {
  if (isSharing) return; // ignore second tap

  isSharing = true;
  try {
    await Share.open({
      url: 'file://' + path,
      type: 'application/pdf',
      failOnCancel: false,
    });
  } catch (err) {
    console.error('Share error:', err);
  } finally {
    isSharing = false;
  }
};
export const downloadFile = async ({
  endpoint,
  fileName = 'download',
  fileExtension = 'pdf',
  headers = {},
}: any) => {
  try {

    const { dirs } = RNFetchBlob.fs;
    const jwt = await getJWT();

    headers = {
      ...headers,
      Authorization: 'Bearer ' + jwt,
      Accept: 'application/pdf',
    };

    if (Platform.OS === 'android') {
      await RNFetchBlob.config({
        addAndroidDownloads: {
          useDownloadManager: true,
          notification: true,
          path: `${dirs.DownloadDir}/${fileName}-${Date.now()}.${fileExtension}`,
          description: 'Downloading file',
          mime: 'application/pdf',
          mediaScannable: true,
        },
      }).fetch('GET', REACT_APP_BASE_API + endpoint, headers);
      console.log('Download started in Download Manager');
    } else {
      // iOS: save to app document directory
      const path = `${dirs.DocumentDir}/${fileName}-${Date.now()}.${fileExtension}`;
      const res = await RNFetchBlob.config({ path }).fetch('GET', REACT_APP_BASE_API + endpoint, headers);
 

      await shareAttachment(path);
      console.log('File saved at:', path);
    }
  } catch (error) {
    console.error('Download failed:', error);
  }
};
